import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  sidebarType: null,
  sidebarProps: {},
  availableTypes: [
    'projectCreate',
    'projectTask',
    'projectCapacity',
    'edit',
    'addBlock',
    'createElement',
    'user',
    'filtersManagement',
    'filtersDashboard',
    'location',
    'posItemEdit',
    'deliveryPlanning',
  ],
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    openSidebar: (state, action) => {
      const { sidebarType, sidebarProps } = action.payload;
      state.isOpen = true;
      state.sidebarType = sidebarType;
      state.sidebarProps = sidebarProps || {};
    },
    closeSidebar: (state) => {
      state.isOpen = false;
      state.sidebarType = null;
      state.sidebarProps = {};
    },
  },
});

export const { openSidebar, closeSidebar } = sidebarSlice.actions;
export default sidebarSlice.reducer;
